import React from 'react'
import { t } from '@lingui/core/macro'
import { Uploader } from '@tecsinapse/cortex-react'
import { useUploaderDialog } from '@/modules/biblioteca-virtual/hooks/use-uploader-dialog'

export const UploaderDialog = ({
  uploader,
  isFolder
}: {
  uploader: ReturnType<typeof useUploaderDialog>
  isFolder: boolean
}) => {
  const { open, onClose, dropzoneProps } = uploader

  return (
    <>
      <Uploader.Modal
        open={open}
        onClose={onClose}
        title={isFolder ? t`Upload de pastas` : t`Upload de arquivos`}
      >
        <div className={'flex flex-col w-full h-full'}>
          <div className={'flex flex-row space-x-deca '}>
            <Uploader.Dropzone
              dropzoneProps={dropzoneProps}
              buttonText={t`Envie aqui`}
              dropText={t`ou clique no botão`}
              selectFileText={
                isFolder
                  ? t`Arraste aqui uma pasta`
                  : t`Arraste aqui um arquivo`
              }
              hasButton={!isFolder}
            />
          </div>
        </div>
      </Uploader.Modal>
    </>
  )
}
